__turbopack_context__.v({
  "greyBg": "Drawer-module__aJGRBW__greyBg",
  "greyScroll": "Drawer-module__aJGRBW__greyScroll",
  "whiteBg": "Drawer-module__aJGRBW__whiteBg",
  "whiteScroll": "Drawer-module__aJGRBW__whiteScroll",
});
